import React from 'react';

import { PanelWrapper, ClickIcon } from 'components';

export const ClicksCard = (props) => {

  const clicks = props.data ? props.data : [];

  return clicks.map((item, index) => {
    return (
      <div className="col-sm" key={index}>
        <PanelWrapper>
          <div className="d-flex flex-wrap justify-content-between">
            <ClickIcon className="icon-click-dashboard mr-3" />
            <div className="d-flex flex-column align-items-end">
              <h5 className="font-weight-bold"> {item.label} </h5>
              <h3 className="text-lg">{item.amount}</h3>
              <h5 className="text-black-50">Cliques</h5>
            </div>
          </div>
        </PanelWrapper>
      </div>
    );
  });
};
